// extracted by mini-css-extract-plugin
module.exports = {"c-create-project-form__body":"CreateProjectForm_c-create-project-form__body__3Dk7B","c-create-project-form__field":"CreateProjectForm_c-create-project-form__field__Lf4Xc"};